import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { TextField, TextFieldSkeleton } from 'components/shared/TextField/TextField';
import { FC, useCallback, useContext } from 'react';
import { useIntl } from 'react-intl';

import { AddonMainFormContext } from '../AddonMainForm.context';

interface OwnProps {
  wrapper?: string;
}

export const Wrapper: FC<OwnProps> = ({ wrapper }) => {
  const { formatMessage } = useIntl();

  const { isLoading } = useContext(AddonMainFormContext);

  const translateWrapper = useCallback(
    (w: string | undefined) =>
      w !== undefined
        ? formatMessage({
            id: `form.Wrapper.${w}` as any,
            defaultMessage: w,
          })
        : '',
    [formatMessage],
  );

  return (
    <BlockOrientationFormGroup inputId="wrapper" label="form.Wrapper">
      {(!isLoading || wrapper !== undefined) && <TextField id="wrapper" value={translateWrapper(wrapper)} isReadOnly />}
      {isLoading && wrapper === undefined && <TextFieldSkeleton />}
    </BlockOrientationFormGroup>
  );
};

Wrapper.displayName = 'Wrapper';
